import './App.css';
import { AllRoutes } from './Pages/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
